import React from "react";
import PropTypes from "prop-types";
import { MrbEditPage } from "mrb/components/layout";
import { MrbFieldInput } from "mrb/components/input";
import { MrbContentLoader } from "mrb/components/loader";
import { defaultTemplate } from "common/hoc";

function LoadioContentProfileEditTemplate({ loadioContentProfileEditViewStore, t }) {
    const { form, loaderStore } = loadioContentProfileEditViewStore;

    return (
        <MrbEditPage store={loadioContentProfileEditViewStore} t={t}>
            <div className="c-container--base">
                <div className="c-card--primary">
                    <MrbContentLoader loaderStore={loaderStore} loaderRender={() => <div />}>
                        {() => (
                            <div className="u-animation--fadeIn">
                                <MrbFieldInput
                                    t={t}
                                    field={form.$("name")}
                                    classNameExtend="c-input--outline"
                                />
                            </div>
                        )}
                    </MrbContentLoader>
                </div>
            </div>
        </MrbEditPage>
    );
}

LoadioContentProfileEditTemplate.propTypes = {
    loadioContentProfileEditViewStore: PropTypes.object.isRequired,
    t: PropTypes.func,
};

export default defaultTemplate(LoadioContentProfileEditTemplate);
